// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3694":"52af937d","9519":"50101db3"}[chunkId] + ".chunk.css";
};